module.exports = __webpack_public_path__ + "static/media/work-with-ai.c0a982a5.png";